import { render } from "./ProductCard.vue?vue&type=template&id=bebc8558&scoped=true"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"

import "./ProductCard.vue?vue&type=style&index=0&id=bebc8558&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-bebc8558"

export default script